import { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { encryptStorage } from '../../CustomStorage';
import {
  GetAllBranchAndregion,
  GetAllZoneHeadOffices,
  GetSearchBranches,
  GetSearchHeadOffices,
  GetSearchRegions,
  GetSearchZones
} from '../../network/AppLevel';
import { APP_CONSTANTS } from '../../URLConstants';
import { GetAllOrganinazations } from '../../network/Organization';
import { GetTaxonomyDetails } from '../../network/Merchants';
import { extractHierarchyInfoFromPath } from '../../utils/Utilities';
import { GetLanguageList } from '../../network/Language';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [sessionUserData, setSessionUserData] = useState(
    encryptStorage.getItem(APP_CONSTANTS.L_KEY_OF_USER_DATA)
  );
  const [languageList, setLanguageList] = useState({});
  const [organzationClientId, setOrganzationClientId] = useState('');
  const [allBOIBranchesRegion, setAllBOIBranchesRegion] = useState({ region: [], branches: [] });
  const [allOrganizationList, setAllOrganizationList] = useState({});
  const [zonesList, setZonesList] = useState([]);
  const [regionsList, setRegionsList] = useState([]);
  const [headOfficesList, setHeadOfficesList] = useState([]);
  const [branchesList, setBranchesList] = useState([]);
  const [accountDetails, setAccountDetails] = useState({});
  const [userLoginOrg, setUserLoginOrg] = useState(
    encryptStorage.getItem(APP_CONSTANTS?.L_ORGANIZATION_IDENTIFIER)
  );
  const [isCheckerMakerRequired, setIsCheckerMakerRequired] = useState(
    encryptStorage.getItem(APP_CONSTANTS.L_KEY_CHECKER_MAKER_REQUIRED)
  );
  const navigate = useNavigate();

  console.log = function () { };
  console.warn = function () { };
  console.error = function () { };

  function getOrgKeyById(orgIdsMap, organizationId) {
    return Object.entries(orgIdsMap).find(([, id]) => id === organizationId)?.[0] || 'UNKNOWN';
  }

  const authenticateSession = (adminData) => {
    const org = getOrgKeyById(
      process.env.REACT_APP_ENVIRONMENT === 'production'
        ? APP_CONSTANTS?.PROD_ORG_IDS
        : APP_CONSTANTS?.UAT_ORG_IDS,
      adminData?.user?.organizationId
    );
    encryptStorage.setItem(APP_CONSTANTS?.L_ORGANIZATION_IDENTIFIER, org);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, true);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, adminData?.token);

    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, adminData);
    if (adminData?.hirerachyEnabled) {
      encryptStorage.setItem(APP_CONSTANTS.L_KEY_CHECKER_MAKER_REQUIRED, 'YES');
      setIsCheckerMakerRequired('YES');
    }
    setSessionUserData(adminData);
    // fetchAllBranchesAndregion();
    if (adminData?.user?.role === APP_CONSTANTS?.USER_ROLE_SUPER_ADMIN) {
      fetchOrganizations();
    }
    setUserLoginOrg(org);
    if (adminData?.user?.taxonomyId) {
      fetchTaxonomyDetails(adminData?.user?.taxonomyId);
    }
  };

  const logoutSession = () => {
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_LOGGEDIN_STATUS, false);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_ADMIN_SSOTOKEN, null);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_OF_USER_DATA, null);
    encryptStorage.setItem(APP_CONSTANTS.L_KEY_CHECKER_MAKER_REQUIRED, 'NO');
    setIsCheckerMakerRequired('NO');

    setSessionUserData(null);
    setOrganzationClientId(null);
    setAllBOIBranchesRegion({});
    navigate('/', { replace: true });
  };

  const fetchAllBranchesAndregion = () => {
    GetAllBranchAndregion(
      process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
        ? 'city'
        : 'branch'
    )
      .then((res) => {
        setAllBOIBranchesRegion((prevState) => ({
          ...prevState,
          branches: res?.data
        }));
      })
      .catch((_err) => { });

    GetAllBranchAndregion(
      process.env.REACT_APP_NOTIFICATION_B2B_CLIENT_ID === APP_CONSTANTS?.CBI_CLIENT_IDENTIFIER
        ? 'state'
        : 'region'
    )
      .then((res) => {
        setAllBOIBranchesRegion((prevState) => ({
          ...prevState,
          region: res?.data
        }));
      })
      .catch((_err) => { });
  };

  function fetchOrganizations() {
    GetAllOrganinazations(1, 50)
      .then((res) => {
        setAllOrganizationList(res?.data);
        console.log(res?.data);
      })
      .catch((err) => { });
  }

  function fetchHeadOfficesList() {
    GetAllZoneHeadOffices({ name: extractHierarchyInfoFromPath(accountDetails?.path)?.headOffice })
      .then((res) => {
        setHeadOfficesList(res?.data?.data);
        return res?.data?.data;
      })
      .catch((Err) => { });
  }

  async function fetchZonesList(headOfficeId) {
    try {
      const res = await GetSearchZones(headOfficeId);
      setZonesList(res?.data);
      return res?.data; // now this actually returns from fetchZonesList
    } catch (err) {
      return [];
    }
  }

  async function fetchRegionList(headOfficeId, zoneOfficeId) {
    try {
      const res = await GetSearchRegions(headOfficeId, zoneOfficeId);
      setRegionsList(res?.data);
      return res?.data;
    } catch (err) {
      return [];
    }
  }

  async function fetchBranchesList(regionalOfficeId) {
    try {
      const res = await GetSearchBranches(regionalOfficeId);
      setBranchesList(res?.data);
      return res?.data;
    } catch (err) {
      return [];
    }
  }

  function fetchTaxonomyDetails(taxonomyId) {
    GetTaxonomyDetails(taxonomyId)
      .then((res) => {
        setAccountDetails(res?.data);
      })
      .catch((err) => { });
  }

  const fetchLanguages = () => {
    GetLanguageList(100, 1, {})
      .then((res) => {
        setLanguageList(res?.data);
      })
      .catch((err) => {
        setLanguageList({});
      });
  };

  return (
    <AuthContext.Provider
      value={{
        sessionUserData,
        organzationClientId,
        allBOIBranchesRegion,
        authenticateSession,
        logoutSession,
        fetchAllBranchesAndregion,
        fetchOrganizations,
        allOrganizationList,
        fetchHeadOfficesList,
        fetchZonesList,
        fetchRegionList,
        fetchBranchesList,
        branchesList,
        zonesList,
        regionsList,
        headOfficesList,
        fetchTaxonomyDetails,
        accountDetails,
        userLoginOrg,
        isCheckerMakerRequired,
        fetchLanguages,
        languageList
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
